module.exports = __webpack_public_path__ + "static/team-nandini-shahi-09e48714d02c3997595a26288fe24b80.jpeg";